import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type SellarMapStoreState = {
  activeId: number | null;
  location: {
    lat: number;
    lng: number;
  } | null;
};

type SellarMapStoreActions = {
  setActiveId: (id: number | null) => void;
  add: (location: SellarMapStoreState["location"]) => void;
  reset: () => void;
};

const initialSellarMapStoreState: SellarMapStoreState = {
  activeId: null,
  location: null,
};

export const useSellarMapStore = create<
  SellarMapStoreState & SellarMapStoreActions
>()(
  persist(
    (set) => ({
      ...initialSellarMapStoreState,
      setActiveId: (activeId: number | null) => set({ activeId }),
      add: (location) =>
        set(() => {
          return {
            location: location,
          };
        }),
      reset: () => set(initialSellarMapStoreState),
    }),
    {
      name: "sellarMapLocation",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        location: state.location,
      }),
    },
  ),
);
